module.exports = __webpack_public_path__ + "img/italy.9779f339.png";